// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"32f57cef","667":"f615dec2","977":"c5dce9b7"}[chunkId] + ".chunk.js";
};